import React from 'react';
import { Form, Radio } from 'antd';
import { AlignLeft, BadgeCheck, FileText } from 'lucide-react';

import './queryDetailsCard.scss';

export interface QueryDetailItem {
  name: string;
  label: string;
  value?: React.ReactNode;
  icon?: React.ElementType;
}

interface QueryDetailsCardProps {
  title: string;
  items: QueryDetailItem[];
  messageLabel?: string;
  message?: React.ReactNode;
  lastStatusName?: string;
  lastStatusLabel?: string;
  lastStatusOptions: { label: string; value: string }[];
}

const QueryDetailsCard = ({
  title,
  items,
  messageLabel = 'Message',
  message,
  lastStatusName = 'lastStatus',
  lastStatusLabel = 'Last Status',
  lastStatusOptions,
}: QueryDetailsCardProps) => (
  <div className="query-details-card">
    <div className="query-details-card__header">
      <h3>{title}</h3>
    </div>

    <div className="query-details-card__grid">
      {items.map(item => {
        const Icon = item.icon || FileText;
        return (
          <div className="query-details-card__item" key={item.name}>
            <div className="query-details-card__label-wrap">
              <div className="query-details-card__icon-box">
                <Icon className="query-details-card__icon" size={18} strokeWidth={2} />
              </div>
              <span className="query-details-card__label">{item.label}</span>
            </div>
            <span className="query-details-card__value">{item.value || '—'}</span>
          </div>
        );
      })}
    </div>

    <div className="query-details-card__message">
      <div className="query-details-card__label-wrap">
        <div className="query-details-card__icon-box">
          <AlignLeft className="query-details-card__icon" size={18} strokeWidth={2} />
        </div>
        <span className="query-details-card__label">{messageLabel}</span>
      </div>
      <div className="query-details-card__message-box">{message || '—'}</div>
    </div>

    <div className="query-details-card__status">
      <div className="query-details-card__label-wrap">
        <div className="query-details-card__icon-box">
          <BadgeCheck className="query-details-card__icon" size={18} strokeWidth={2} />
        </div>
        <span className="query-details-card__label">{lastStatusLabel}</span>
      </div>
      <Form.Item name={lastStatusName} colon={false}>
        <Radio.Group options={lastStatusOptions} />
      </Form.Item>
    </div>
  </div>
);

export default QueryDetailsCard;
